module.exports = __webpack_public_path__ + "img/visa.50ae0a4a.svg";